import CONSTANTS from "constants/Constants";

const { MX_DOMAIN } = CONSTANTS.EMAIL_DISABLED_REASONS;
const { INVALID } = CONSTANTS.EMAIL_DOMAIN_STATUS;

// The disabled_reason clause covers an address the domain check switched off
// whose domain has since started resolving: validation only ever disables, so
// without it that address would lose its explanation.
const hasInvalidEmailDomain = ({ enabled, disabled_reason, domain_status }) =>
  domain_status === INVALID ||
  (enabled === false && disabled_reason === MX_DOMAIN);

const isContactEmailable = contact => {
  return contact.email_addresses?.some(
    ({ enabled, subscribed }) => enabled && subscribed
  );
};

const isContactCallable = contact => {
  return contact.phone_numbers?.some(
    ({ enabled, is_callable }) => enabled && is_callable
  );
};

// Copies before sorting: the input is usually component state.
const sortEmailAddressesByPrimary = emailAddresses =>
  [...(emailAddresses ?? [])].sort(
    (a, b) => Number(b.is_primary) - Number(a.is_primary)
  );

export {
  hasInvalidEmailDomain,
  isContactEmailable,
  isContactCallable,
  sortEmailAddressesByPrimary,
};
